import API_URLS from '../../constants/api-urls';
import axios from '../../utils/axios';

export type SubscribeSchoolArgs = { materialId: number; reason?: string };

const subscribeSchool = ({ materialId, reason }: SubscribeSchoolArgs): Promise<void> => {
    const params: Record<string, string> = {
        subjectType: 'material',
        subjectId: String(materialId)
    };

    const trimmed = reason?.trim();

    if (trimmed) {
        params.reason = trimmed;
    }

    return axios.post(API_URLS.SUBSCRIPTION.FOLLOW_SCHOOL, params) as unknown as Promise<void>;
};

export default subscribeSchool;
